import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=b3c89f92&scoped=true"
import script from "./supplier.vue?vue&type=script&lang=js"
export * from "./supplier.vue?vue&type=script&lang=js"
import style0 from "./supplier.vue?vue&type=style&index=0&id=b3c89f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c89f92",
  null
  
)

export default component.exports